export const returnFields = [

    {
        name: "itemCategory",
        label: "Item Category",
        type: "select",
        required: true
    },

    {
        name: "itemSubCategory",
        label: "Item Sub Category",
        type: "select",
        required: true
    },

    {
        name: "returnReasonCodes",
        label: "Return Reason Codes",
        type: "text"
    },

    {
        name: "returnWindowDays",
        label: "Return Window (Days)",
        type: "number"
    },

    {
        name: "exchangeReasonCodes",
        label: "Exchange Reason Codes",
        type: "text"
    },

    {
        name: "exchangeWindowDays",
        label: "Exchange Window (Days)",
        type: "number"
    },

    { name: "createdBy", label: "Created By", readonly: true },
    { name: "createdDate", label: "Created Date", readonly: true },
    { name: "updatedBy", label: "Updated By", readonly: true },
    { name: "updatedDate", label: "Updated Date", readonly: true }

];